import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

export const exportToExcel = (data, fileName, sheetName, merges = []) => {

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    if (Array.isArray(merges) && merges.length > 0) {
        worksheet["!merges"] = merges;
    }

    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {

            const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });

            if (!worksheet[cellAddress]) continue;

            const isHeader = R === 0;

            worksheet[cellAddress].s = {
                font: {
                    bold: isHeader,
                    sz: isHeader ? 14 : 11,
                },
                alignment: {
                    vertical: "center",
                    horizontal: "center",
                    wrapText: true,
                },
            };
        }
    }

    const columnWidths = Object.keys(data[0]).map((key) => ({
        wch: Math.max(
            key.length,
            ...data.map((row) =>
                row[key] ? row[key].toString().length : 0
            )
        ) + 4
    }));

    worksheet["!cols"] = columnWidths;

    const totalRows = data.length + 1;

    worksheet["!rows"] = Array.from({ length: totalRows }, (_, i) => ({
        hpx: i === 0 ? 35 : 28
    }));

    worksheet["!views"] = [
        {
            state: "frozen",
            //xSplit: 1,
            ySplit: 1
        }
    ];

    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        sheetName || "Sheet1"
    );

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
    });

    const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
    });

    saveAs(blob, `${fileName}.xlsx`);

    return true;
};